export default "__VITE_ASSET__8u6xYwqw__"